import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { AisleResponse, GridResponse, LayoutMapDetailResponse } from './types'


export const getLayoutGrid = (warehouseId: number, brand?: string | null) =>
  axios.get<GridResponse>(`${ApiConfig.LayoutMapApi}/grid`, {
    params: { warehouseId, ...(brand ? { brand } : {}) }
  })

export const getLayoutAisle = (aisle: string, warehouseId: number, brand?: string | null) =>
  axios.get<AisleResponse>(`${ApiConfig.LayoutMapApi}/aisle/${aisle}`, {
    params: { warehouseId, ...(brand ? { brand } : {}) }
  })

export const getLayoutDetail = (
  warehouseId: number,
  aisle: string,
  column: string,
  level?: string,
  slot?: string
) =>
  axios.get<LayoutMapDetailResponse>(`${ApiConfig.LayoutMapApi}/detail`, {
    params: {
      warehouseId,
      aisle,
      column,
      ...(level !== undefined ? { level } : {}),
      ...(slot !== undefined ? { slot } : {})
    }
  })

export const clearLayoutCache = (warehouseId: number) =>
  axios.delete(`${ApiConfig.LayoutMapApi}/cache`, {
    params: { warehouseId }
  })
